import Router from "./app/Router";

function App() {
  return <Router />;
}

export default App;
